export default defineAppConfig({
  env: import.meta.env.VITE_ENVIRONMENT,
  release: import.meta.env.VITE_RELEASE,
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL,
  },
  echo: {
    wsAppKey: import.meta.env.VITE_ECHO_WS_APP_KEY,
    wsHost: import.meta.env.VITE_ECHO_WS_HOST,
    wsPort: import.meta.env.VITE_ECHO_WS_PORT || 443,
    wsPath: import.meta.env.VITE_ECHO_WS_PATH || '/ws',
    wsScheme: import.meta.env.VITE_ECHO_WS_SCHEME || 'https',
    wsAuthEndpoint: import.meta.env.VITE_ECHO_WS_AUTH_ENDPOINT
  },
  gtm: {
    id: import.meta.env.VITE_GTM_CODE || 'GTM-UNDEFINED'
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },
  telegram: {
    bot_link: import.meta.env.VITE_TELEGRAM_BOT_LINK
  },
  yandex: {
    metrika: {
      web: import.meta.env.VITE_YANDEX_METRIKA_WEB_ID,
      mini_app: import.meta.env.VITE_YANDEX_METRIKA_MINI_APP_ID
    }
  }
});